import * as calls from './libs';

const Web3RpcCalls = {
  eth_syncing: {
    description:
      'Returns an object with data about the sync status or false.',
    web3: calls.web3.default.eth_syncing,
    ethers: calls.ethers.default.eth_hashrate,
  },
  eth_hashrate: {
    description:
      'Returns the number of hashes per second that the node is mining with.',
    web3: calls.web3.default.eth_hashrate,
    ethers: calls.ethers.default.eth_hashrate,
  },
  eth_gasPrice: {
    description: 'Returns the current price per gas in wei.',
    web3: calls.web3.default.eth_gasPrice,
    ethers: calls.ethers.default.eth_gasPrice,
  },
  eth_accounts: {
    description: 'Returns a list of addresses owned by client.',
    web3: calls.web3.default.eth_accounts,
    ethers: calls.ethers.default.eth_accounts,
  },
  eth_blockNumber: {
    description: 'Returns the number of most recent block.',
    web3: calls.web3.default.eth_blockNumber,
    ethers: calls.ethers.default.eth_blockNumber,
  },
  eth_getBalance: {
    description: 'Returns the balance of the account of given address.',
    web3: calls.web3.default.eth_getBalance,
    ethers: calls.ethers.default.eth_getBalance,
  },
  eth_getStorageAt: {
    description:
      'Returns the value from a storage position at a given address.',
    web3: calls.web3.default.eth_getStorageAt,
    ethers: calls.ethers.default.eth_getStorageAt,
  },
  eth_getTransactionCount: {
    description: 'Returns the number of transactions sent from an address.',
    web3: calls.web3.default.eth_getTransactionCount,
    ethers: calls.ethers.default.eth_getTransactionCount,
  },
  eth_getBlockTransactionCountByHash: {
    description:
      'Returns the number of transactions in a block from a block matching the given block hash.',
    web3: calls.web3.default.eth_getBlockTransactionCountByHash,
    ethers: calls.ethers.default.eth_getBlockTransactionCountByHash,
  },
  eth_getBlockTransactionCountByNumber: {
    description:
      'Returns the number of transactions in a block matching the given block number.',
    web3: calls.web3.default.eth_getBlockTransactionCountByNumber,
    ethers: calls.ethers.default.eth_getBlockTransactionCountByNumber,
  },
  eth_getCode: {
    description: 'Returns code at a given address.',
    web3: calls.web3.default.eth_getCode,
    ethers: calls.ethers.default.eth_getCode,
  },
  eth_sendRawTransaction: {
    description:
      'Creates new message call transaction or a contract creation for signed transactions.',
    web3: calls.web3.default.eth_sendRawTransaction,
    ethers: calls.ethers.default.eth_sendRawTransaction,
  },

  // Supported in Web3API, but doesn't work here

  // eth_call: {
  //   description: 'Call any read-only function on a deployed contract',
  //   web3: calls.web3.default.eth_call,
  //   ethers: calls.ethers.default.eth_call,
  // },
  // eth_estimateGas: {
  //   disabled: true,
  //   description: '🚫 This method is not YET supported in Web3API!',
  //   web3: calls.web3.default.eth_estimateGas,
  //   ethers: calls.ethers.default.eth_estimateGas,
  // },
  
  eth_getBlockByHash: {
    description: 'Returns information about a block by hash.',
    web3: calls.web3.default.eth_getBlockByHash,
    ethers: calls.ethers.default.eth_getBlockByHash,
  },
  eth_getBlockByNumber: {
    description: 'Returns information about a block by block number.',
    web3: calls.web3.default.eth_getBlockByNumber,
    ethers: calls.ethers.default.eth_getBlockByNumber,
  },
  eth_getTransactionByHash: {
    description:
      'Returns the information about a transaction requested by transaction hash.',
    web3: calls.web3.default.eth_getTransactionByHash,
    ethers: calls.ethers.default.eth_getTransactionByHash,
  },
  eth_getTransactionByBlockHashAndIndex: {
    description:
      'Returns information about a transaction by block hash and transaction index position.',
    web3: calls.web3.default.eth_getTransactionByBlockHashAndIndex,
    ethers: calls.ethers.default.eth_getTransactionByBlockHashAndIndex,
  },
  eth_getTransactionByBlockNumberAndIndex: {
    description:
      'Returns information about a transaction by block number and transaction index position.',
    web3: calls.web3.default.eth_getTransactionByBlockNumberAndIndex,
    ethers: calls.ethers.default.eth_getTransactionByBlockNumberAndIndex,
  },
  eth_getTransactionReceipt: {
    description: 'Returns the receipt of a transaction by transaction hash.',
    web3: calls.web3.default.eth_getTransactionReceipt,
    ethers: calls.ethers.default.eth_getTransactionReceipt,
  },
  eth_getUncleByBlockHashAndIndex: {
    description:
      'Returns information about a uncle of a block by hash and uncle index position.',
    web3: calls.web3.default.eth_getUncleByBlockHashAndIndex,
    ethers: calls.ethers.default.eth_getUncleByBlockHashAndIndex,
  },
  eth_getUncleByBlockNumberAndIndex: {
    description:
      'Returns information about a uncle of a block by number and uncle index position.',
    web3: calls.web3.default.eth_getUncleByBlockNumberAndIndex,
    ethers: calls.ethers.default.eth_getUncleByBlockNumberAndIndex,
  },
  eth_getUncleCountByBlockHash: {
    description:
      'Returns the number of uncles in a block from a block matching the given block hash.',
    web3: calls.web3.default.eth_getUncleCountByBlockHash,
    ethers: calls.ethers.default.eth_getUncleCountByBlockHash,
  },
  eth_getUncleCountByBlockNumber: {
    description:
      'Returns the number of uncles in a block from a block matching the given block number.',
    web3: calls.web3.default.eth_getUncleCountByBlockNumber,
    ethers: calls.ethers.default.eth_getUncleCountByBlockNumber,
  },
};

export default Web3RpcCalls;
